import { createContext } from "react";

const initialState = {
  isApprovedUser: false,
  displayPendingUserAccountMessage: undefined,
  setIsApprovedUser: () => null
};

export const SignInContext = createContext(initialState);
